import { render, staticRenderFns } from "./VersionEdit.vue?vue&type=template&id=386223fa&scoped=true"
import script from "./VersionEdit.vue?vue&type=script&lang=js"
export * from "./VersionEdit.vue?vue&type=script&lang=js"
import style0 from "./VersionEdit.vue?vue&type=style&index=0&id=386223fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386223fa",
  null
  
)

export default component.exports